import { Box, Text } from "grommet";
import { extractLinks } from "../../utils/linkUtils";

export const LinkRenderer = ({ text }) => {

    const links = extractLinks(text).links;

    if (links.length === 0) return <span>{text}</span>;

    const parts = [];
    let lastIndex = 0;

    links.forEach((link, i) => {
        // add plain text before link
        if (lastIndex < link.start) {
            parts.push(<span key={`text-${i}`}>{text.slice(lastIndex, link.start)}</span>);
        }

        // add link
        parts.push(
            // <Text margin={'none'} truncate="tip">
                <a
                    key={`link-${i}`}
                    href={text.substring(link.start, link.end)}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="link"
                    style={{ wordWrap: "break-word" }}
                >
                    {text.substring(link.start, link.end)}
                </a>
            // </Text>
        );

        lastIndex = link.end;
    });

    // add remaining text
    if (lastIndex < text.length) {
        parts.push(<span key="last">{text.slice(lastIndex)}</span>);
    }

    return parts;
}